export enum FinalWorklistStatus {
  AUTHORIZED_WITH_AUTH_ON_FILE = "Authorized with Auth on File",
  REQUIRED = "Required",
  AUTHORIZED_WITH_NO_AUTH_REQUIRED = "Authorized with No Auth Required",
  AUTHORIZED_WITH_APPROVAL = "Authorized with Approval",
  AUTHMATE_PENDING = "Authmate Pending",
  AUTH_ISSUE_ONSITE = "Auth Issue (Onsite)",
  DENIED = "Denied",
  FINANCIAL = "Financial",
  AUTHORIZED = "Authorized",
  NOT_AVAILABLE = "Not Available",
}
